import { Component, inject, OnInit } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { CHANGE_PASSWORD, MEMBER_PROFILE } from '@src/app/core/constants';
import { HelperService } from '@src/app/core/services';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { finalize, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  standalone: false,
  styleUrl: './view.component.scss'
})
export class ViewComponent extends CoreClass implements OnInit {
  data: any;
  isEdit: Boolean = false
  isPassword: Boolean = false
  isToast: string = ""
  errorMessage: string = ""
  timezoneData = []
  ngxService = inject(NgxUiLoaderService)
  
  helperService = inject(HelperService)
  ngOnInit(): void {
    this.getPersonalInfo()
    this.getTimeZones()
  }
  
getPersonalInfo(toggle?: boolean) {
  this.ngxService.start();

  this.apiService.getUserDetails()
    .pipe(takeUntil(this.onDestroy$))
    .subscribe(
      (response: any) => {
         this.data = response.data
          this.data.profile.phoneMobileDisplay = this.formatPhoneNumber(this.data?.profile?.phoneMobile);
        if (toggle) {
          this.toggleEdit();
        }

        this.ngxService.stop(); 
      },
      (error) => {
        console.error(error);
        this.ngxService.stop(); 
      }
    );
}

  formatPhoneNumber(num: any): any {
    const digits = num.toString().replace(/\D/g, '');

    // Assuming it's a US-style number (11 digits including country code)
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 11);
    return `(+1) ${part1} - ${part2} - ${part3}`;
  }
  toggleEdit = () => {
    this.isEdit = !this.isEdit
  }
  togglePassword = () => {
    this.isPassword = !this.isPassword
  }
  getTimeZones = () => {
    this.apiService.getTimeZones().subscribe(
      (response: any) => {
        this.timezoneData = response.data
        this.ngxService.stop(); 
      }
      
    )
  }
  changePassword = (body: any) => {
    this.ngxService.start();
    if (body.oldPassword === body.newPassword) {
      this.ngxService.stop();
      this.errorMessage = ""
      this.displayMessage("error")
      this.sharedService.removeLoader()
       this.ngxService.stop();
    }
    else {
      this.helperService.isLoading = true
      this.apiService.changePassword(body)
        .subscribe(
          (response: any) => {
            this.helperService.isLoading = false

            if (response?.body?.status?.result === "FAILURE") {
              this.ngxService.stop();
              this.errorMessage = response.body.status.message.details;
              this.displayMessage(this.errorMessage ? "error" : "");
              
            } else {
              this.ngxService.stop();
              this.displayMessage("success")
              this.togglePassword()
              this.sharedService.resetPasswordForm.next(true)
              this.sharedService.removeLoader();
              
              
            }
            this.ngxService.stop();
  
          },
          (error: any) => {
            this.helperService.isLoading = false
            this.errorMessage = "Bad credentials"
            this.displayMessage("error")
            this.sharedService.removeLoader()
            this.ngxService.stop();


          }
        )
    }
  }
  displayMessage = (message: string) => {
    this.isToast = message
    setTimeout(() => {
      this.isToast = ""
    }, 2000);
  }
}
